<template>
  <li class="dropdown nav-item"
      :is="tag"
      :class="{show: isOpen, 'dropdown-up': dropUp}"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      @click="toggleDropDown"
      v-click-outside="closeDropDown">

    <button class="btn border-0 nav-link dropdown-toggle"
       data-toggle="dropdown">
      <slot name="title">
        <i :class="icon"></i>
        <span>{{title}}</span>
        <b v-show="isOpen" class="caret"></b>
      </slot>
    </button>
    <div ref="menu"
         class="dropdown-menu show"
         :class="menuAlign === 'left' ? 'dropdown-menu-left' : 'dropdown-menu-right'"
         v-show="isOpen">
      <slot></slot>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'base-dropdown',
    props: {
      title: String,
      icon: String,
      tag: {
        type: String,
        default: 'li'
      },
      // Edge of the toggle the menu is anchored to. Defaults to 'right' (the
      // historical behaviour); pass 'left' when the menu would otherwise spill
      // over to the left of its button.
      menuAlign: {
        type: String,
        default: 'right',
        validator: value => ['left', 'right'].indexOf(value) !== -1
      }
    },
    data () {
      return {
        isOpen: false,
        // The menu hangs below its button by default and is flipped above it
        // when there is no room left down there. See _updateDropDirection.
        dropUp: false
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          // The menu is only measurable once it is on screen.
          this.$nextTick(this._updateDropDirection)
        }
        this.$emit('change', this.isOpen)
      },
      closeDropDown () {
        this.isOpen = false
        this.dropUp = false
        this.$emit('change', this.isOpen)
      },
      // Decides which way the menu opens. On the last rows of a listing there
      // is no room below the button, and the menu came up cut off by the edge
      // of the pane (or of the window); it is flipped above the button instead
      // whenever that leaves more of it visible.
      _updateDropDirection () {
        const menu = this.$refs.menu
        if (!menu) return
        const anchor = this.$el.getBoundingClientRect()
        const limits = this._clippingLimits()
        const spaceBelow = limits.bottom - anchor.top
        const spaceAbove = anchor.bottom - limits.top
        this.dropUp = menu.offsetHeight > spaceBelow && spaceAbove > spaceBelow
      },
      // Edges beyond which the menu would be cut: those of the window, closed
      // in by every ancestor that clips what overflows it. The listing pane
      // scrolls, so its own bottom edge is the one that hides the menu long
      // before the window does.
      _clippingLimits () {
        const limits = {top: 0, bottom: window.innerHeight}
        let node = this.$el.parentElement
        while (node && node !== document.body) {
          const style = window.getComputedStyle(node)
          if (/(auto|scroll|hidden)/.test(style.overflowY + style.overflowX)) {
            const rect = node.getBoundingClientRect()
            limits.top = Math.max(limits.top, rect.top)
            limits.bottom = Math.min(limits.bottom, rect.bottom)
          }
          node = node.parentElement
        }
        return limits
      }
    }
  }
</script>
<style scoped>
  .dropdown .dropdown-toggle{
    cursor: pointer;
  }
  /* Flipped menu: its bottom is pinned to the button instead of its top. The
     listing gives its menus a position of its own, so it repeats this rule for
     them; this one covers every other dropdown of the application. */
  .dropdown-up .dropdown-menu{
    top: auto;
    bottom: 100%;
  }
</style>
